import { createAction } from 'redux-actions';

export const requestScheduleToursAction = createAction('REQUEST/TOURS');
export const requestUpdateScheduleTourAction = createAction('REQUEST/UPDATE_TOURS');
export const requestCancelScheduleTourAction = createAction('REQUEST/CANCEL_TOUR');
export const requestBatchCancelScheduleTourAction = createAction('REQUEST/CANCEL_TOURS');
